module.exports = __webpack_public_path__ + "static/media/nynorsk-dyslexia-confimation.ee06c652.pdf";